import styled from 'styled-components';
import cores from '../../../styles/cores';

interface CopyButtonProps {
  copied: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100vw;
  height: 100vh;
  overflow-x: auto;
`;

export const DetalhesContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 50px;
  width: 90%;
  height: fit-content;
  align-self: center;
  border-radius: 8px;
  box-shadow: 0px 0px 6px 2px rgba(12, 12, 14, 0.2);
  margin-bottom: 40px;

  h1 {
    align-self: flex-start;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 20px;
    font-size: 24px;
    font-weight: bold;
  }
`;

export const DetalhesHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 50px;
  .btn {
    margin-right: 30px;
    height: 50px;
  }
`;

export const Usuario = styled.div`
display: flex;
align-items: center;
justify-content: center;
margin-left: 20px;

h1 {
  align-self: center;
}
svg {
}
`;

export const BotoesContainer = styled.div`
  display: flex;
  border: 0px solid black;
  align-self: flex-end;
  margin-top: 40px;
  padding: 0;
  width: 100%;

  .btn-salvar {
    width: 200px;
    margin-right: 20px;
  }

  .btn-exluir {
  }
`;

export const TrocarFoto = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #121212;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate(-45px, 45px);
  background-color: white;
  cursor: pointer;
  svg {
    font-size: 26px;
    fill: ${cores.black};
  }
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: fit-content;
  height: 100%;

  .endereco {
    width: 100%;
    font-size: 20px;
    margin: 15px 0;
    h1 {
      font-weight: bold;
    }
  }
`;

export const DetalhesContent = styled.div`
  display: flex;
  border: 0px solid black;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  max-width: 100%;
  margin-left: 20px;
  margin-bottom: 20px;

  .item {
    display: flex;
    flex-direction: column;
    border: 0px solid black;
    width: fit-content;
    margin-top: 10px;
    margin-right: 50px;

    h2 {
      font-size: 18px;
      font-weight: bold;
    }
  }
`;

export const InputsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 0px;
  padding: 0;
  margin: 10px 10px;
  max-width: 100%;
  .input {
    width: 250px;
  }
`;

export const InputsContent = styled.div`
  display: flex;
  border: 0px solid black;
  flex-wrap: wrap;
  max-width: 100%;

  padding: 0;
`;

export const ContainerClipBoard = styled.div`
  position: relative;
  display: inline-block;
  width: 300px;
  margin-right: 30px;
`;

export const InputFieldClipBoard = styled.input`
  padding: 8px 40px 8px 12px;
  font-size: 16px;
  border-radius: 4px;
  border: 1px solid #ddd;
  width: 100%;
  box-sizing: border-box;
`;

export const CopyButton = styled.button<CopyButtonProps>`
  position: absolute;
  right: 8px;
  bottom: 10%;
  cursor: pointer;
  border: none;
  background: none;
  padding: 0;
  color: ${(props) => (props.copied ? '#4caf50' : '#666')};
  transition: color 0.2s ease-in-out;
  &:hover {
    background-color: #ccc8c8;
  }
`;

export const CopiedMessage = styled.span`
  color: green;
  font-size: 12px;
  margin-top: 30px;
`;
